/**
 * Configuration for the application
 * Centralizes environment-specific settings
 */

// Determine the API Base URL based on environment
// Force production URL if in production mode to avoid localhost leaks
const IS_PROD = import.meta.env.PROD || import.meta.env.MODE === 'production';

export const API_BASE_URL = 
  (IS_PROD 
    ? "https://api.vozflow.dev/api/v1" 
    : (import.meta.env.VITE_BACKEND_URL || "http://localhost:8080/api/v1"));

// Root URL for health checks (without /api/v1)
export const API_ROOT_URL = IS_PROD 
  ? "https://api.vozflow.dev" 
  : (import.meta.env.VITE_BACKEND_URL?.replace('/api/v1', '') || "http://localhost:8080");

console.log(`[Config] API Base URL: ${API_BASE_URL} (Mode: ${import.meta.env.MODE}, PROD: ${IS_PROD})`);

